import '../../../styles/variables-mixins.sass';
import '../../../styles/app.sass';

import './eula/EulaView.sass';
import './home/homeView.sass';
